import { Alert, Box } from '@a0/quantum-product';
import * as React from 'react';
export var AlertContainer = function (_a) {
    var _b = _a.children, children = _b === void 0 ? '' : _b, _c = _a.severity, severity = _c === void 0 ? 'default' : _c;
    return (React.createElement(Alert, { className: "alert-portal-container alert-portal-severity-".concat(severity), severity: severity, variant: "standard" },
        React.createElement(Box, { className: "alert-portal-content", dangerouslySetInnerHTML: {
                __html: children,
            } })));
};
